import React from 'react';
// import Typed from 'react-typed';
import { Link, useNavigate } from 'react-router-dom';

import banner from './img/banner.png';
import { useState } from 'react';

const SlideSec = () => {
	const navigate=useNavigate();
	const [conNumber,setConNumber] = useState("")
	const onClick=()=>{
		if(conNumber)
		navigate(`/tracking/${conNumber}`);
	}
	return (
		<div>
			<div className="bg-gradient-to-r z-auto   from-blue-600 to-blue-500 w-full h-[500px] justify-center items-center flex flex-col mb-20 max-[480px]:mb-0">
					<img
						className="w-full h-screen object-contain object-cover   "
						src={banner}
						alt=""
					/>
				<div className="absolute  ">
					<h3 className=" md:text-6xl sm:text-4xl max-[480px]:text-center max-[480px]:text-3xl  text-white  mb-5 font-semibold">Track Your Shipment</h3>
					<div className=" ">
						<div class="flex  items-center justify-center  ">
							<div class="flex   border-2 border-gray-200 rounded rounded-full ">
								<input
									type="text"
									onChange={(e)=>setConNumber(e.target.value)}
									class="px-6 py-4 w-96 lg:w-96 max-[480px]:w-56 rounded-full outline-2 outline-double outline-blue-500/50 rounded-r-none"
									placeholder="Search..."
								/>

								<button onClick={onClick} class={`${conNumber?"":"opacity-25"} px-4 text-white bg-blue-600 border-l rounded-l-none  rounded-full`} >
									{/* {conNumber?(<Link disabled to={`/tracking/${conNumber}`}>Search</Link>):("Search")} */}
									Search
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <Typed className='md:text-6xl sm:text-4xl text-white font-normal pt-5 ' strings={['Credence Resources']}
                    typeSpeed={40}
                    backSpeed={40} 
                    loop
                /> */}
			</div>
		</div>
	);
};

export default SlideSec;
